/** Remote flow VPS (Theta + QuestDB + smart-flow). Keep in sync with docker-compose REMOTE_FLOW_UPSTREAM. */
export const REMOTE_FLOW_HOST = '212.193.3.56';
export const REMOTE_FLOW_PORT = 5001;
export const REMOTE_FLOW_HTTP_BASE = `http://${REMOTE_FLOW_HOST}:${REMOTE_FLOW_PORT}`;
/** Shown in UI errors / ops hints (not used for fetch URLs in production — same-origin proxy). */
export const REMOTE_FLOW_LABEL = `${REMOTE_FLOW_HOST}:${REMOTE_FLOW_PORT}`;
